let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("8Ned5"), load("eEX4w")]).then(() => parcelRequire('c2BSo'));